import {
  DESCRIPTION, ID, IS_COMMENTABLE, MA_ID, NAME, OPTIONS, QUESTION_TYPE, QUESTIONS, STANDARD_ID, STATUS,
} from 'constants/formFields';

import type { IGetSurveyDefaultValues } from './interfaces/IGetSurveyDefaultValues';

const SURVEY_DEFAULT_VALUES = {
  NAME: '',
  DESCRIPTION: '',
  MA_ID: 0,
  STANDARD_ID: undefined,
  STATUS: 'draft' as const,
  QUESTIONS: [],
};

const QUESTION_DEFAULT_VALUES = {
  NAME: '',
  QUESTION_TYPE: 'short-answer' as const,
  IS_COMMENTABLE: false,
  OPTIONS: [],
};

function getSurveyDefaultValues({ values, maId }: IGetSurveyDefaultValues) {
  if (!values) {
    return {
      [NAME]: SURVEY_DEFAULT_VALUES.NAME,
      [DESCRIPTION]: SURVEY_DEFAULT_VALUES.DESCRIPTION,
      [MA_ID]: maId || SURVEY_DEFAULT_VALUES.MA_ID,
      [STANDARD_ID]: SURVEY_DEFAULT_VALUES.STANDARD_ID,
      [STATUS]: SURVEY_DEFAULT_VALUES.STATUS,
      [QUESTIONS]: SURVEY_DEFAULT_VALUES.QUESTIONS,
    };
  }

  const { name, description, questions } = values;

  return {
    [NAME]: name || SURVEY_DEFAULT_VALUES.NAME,
    [DESCRIPTION]: description || SURVEY_DEFAULT_VALUES.DESCRIPTION,
    [MA_ID]: maId || SURVEY_DEFAULT_VALUES.MA_ID,
    [STANDARD_ID]: SURVEY_DEFAULT_VALUES.STANDARD_ID,
    [STATUS]: SURVEY_DEFAULT_VALUES.STATUS,
    [QUESTIONS]: questions?.map((q: any) => ({
      [NAME]: q.question || q.name || QUESTION_DEFAULT_VALUES.NAME,
      [QUESTION_TYPE]: q.questionType || QUESTION_DEFAULT_VALUES.QUESTION_TYPE,
      [IS_COMMENTABLE]: q.isCommentable || QUESTION_DEFAULT_VALUES.IS_COMMENTABLE,
      [OPTIONS]: q.matchedKeywords?.map((keyword: string, index: number) => ({
        [NAME]: keyword,
        ...(q.id && { [ID]: index + 1 }),
      })) || q.options?.map((opt: any) => ({
        [NAME]: opt.name || '',
        ...(opt.id && { [ID]: opt.id }),
      })) || QUESTION_DEFAULT_VALUES.OPTIONS,
      ...(q.id && { [ID]: q.id }),
    })) || SURVEY_DEFAULT_VALUES.QUESTIONS,
  };
}

export default getSurveyDefaultValues;
